import "./QuickStart.css";
import * as React from 'react';
import LetsStart from "../LetsStart";
import MoreResources from "../MoreResources";
import RequestDemo from "./RequestDemo";
import ContactUs from "./ContactUs";
import HelpGuide from "./HelpGuide";
import WhatsNew from "../WhatsNew";
import VideoBox from "../VideoBox";
import AiInsights from "../AiInsights";
import { ProductType } from "../../../store/Tenant";
import ppmxOverviewPreviewImg from "../../../images/ppmx-overview-video-preview.svg";
import ppmxForTeamMembersPreviewImg from "../../../images/ppmx-for-team-members-video-preview.svg";
import ppmxTaskManagementPreviewImg from "../../../images/ppmx-task-management-video-preview.svg";
import ppmxTimeTrackingPreviewImg from "../../../images/ppmx-time-tracking-video-preview.svg";
import G2ReviewWidget from "./G2ReviewWidget";

type Props = {
    isTrial: boolean;
    hasPartnersSupport: boolean;
    hasRequestDemo: boolean;
    productType: ProductType;
}

const QuickStartTeamMember = (props: Props) => {

    const _renderVideo = () => {
        switch (props.productType) {
            case ProductType.Enterprise:
                return <>
                    <VideoBox text="PPM Express Overview" previewImg={ppmxOverviewPreviewImg} href="https://vimeo.com/685714660" />
                    <VideoBox text="Overview for Team Members" previewImg={ppmxForTeamMembersPreviewImg} href="https://vimeo.com/1027302351" />
                    <VideoBox text="PPM Express Time Tracking" previewImg={ppmxTimeTrackingPreviewImg} href="https://vimeo.com/991511091" />
                </>
            case ProductType.Product:
            case ProductType.Portfolio:
                return <>
                    <VideoBox text="PPM Express Overview" previewImg={ppmxOverviewPreviewImg} href="https://vimeo.com/685714660" />
                    <VideoBox text="Overview for Team Members" previewImg={ppmxForTeamMembersPreviewImg} href="https://vimeo.com/1027302351" />
                    <VideoBox text="PPM Express Task Management" previewImg={ppmxTaskManagementPreviewImg} href="https://vimeo.com/991507302" />
                </>
            case ProductType.Once:
                return <>
                    <VideoBox text="PPM Express Overview" previewImg={ppmxOverviewPreviewImg} href="https://vimeo.com/1072513097" />
                    <VideoBox text="Overview for Team Members" previewImg={ppmxForTeamMembersPreviewImg} href="https://vimeo.com/1027302351" />
                    <VideoBox text="PPM Express Time Tracking" previewImg={ppmxTimeTrackingPreviewImg} href="https://vimeo.com/991511091" />
                </>
            default:
                return <>
                    <VideoBox text="PPM Express Overview" previewImg={ppmxOverviewPreviewImg} href="https://vimeo.com/991507263" />
                    <VideoBox text="Overview for Team Members" previewImg={ppmxForTeamMembersPreviewImg} href="https://vimeo.com/1027302351" />
                    <VideoBox text="PPM Express Time Tracking" previewImg={ppmxTimeTrackingPreviewImg} href="https://vimeo.com/991511091" />
                </>
        }
    }

    const renderOnboardingContent = () => {
        if (props.hasPartnersSupport) {
            return null;
        }

        if (props.isTrial && props.hasRequestDemo) {
            return <RequestDemo />;
        }

        return <ContactUs />;
    };

    return <>
        <div className="row">
            <AiInsights />
        </div>
        <G2ReviewWidget className="row" />
        <div className="row">
            <div className="column double">
                <div className="column">
                    <LetsStart />
                </div>
            </div>
            <div className="row-double">
                {renderOnboardingContent()}
                <HelpGuide />
            </div>
        </div>
        <div className="row withVideo">
            {_renderVideo()}
        </div>
        <div className="row">
            <div className="column double">
                <div className="column">
                    <MoreResources />
                </div>
            </div>
            <WhatsNew />
        </div>
    </>;
}

export default QuickStartTeamMember;
